if (!customElements.get("interactive-layers-controller")) {

  class InteractiveLayers extends Element {
    get refs() {
      const productMedia = document.querySelector("product-media");
      const $layersContainer = this.$el.find(`[slot="layers"]`);
      return {
        $layersContainer,
        productMedia,
      };
    }

    constructor() {
      super();
    }

    closeAll() {
      this.$el.find("interactive-layer").each((function() {
        this.close();
      }));
    }
  }

  customElements.define("interactive-layers", InteractiveLayers);

  class InteractiveLayer extends Element {

    isOpen = false;

    activeContent = null;

    slots = {
      content: null,
    };

    get refs() {
      const $productMedia = this.$el.closest("product-media");
      const parent = this.parentElement;
      const $ancestor = this.$el.closest("interactive-layers");

      const otherThumbnails = parent.querySelectorAll(`interactive-layer:not(${this.id}) .hotspot-thumbnail`);
      const otherLayers = [...parent.querySelectorAll(`interactive-layer:not(${this.id})`)];

      const hotspotEl = this.querySelector(`#${this.id}-hotspot`);
      const thumbnailEL = this.querySelector(`#${this.id}-thumbnail`);
      const contentEl = this.querySelector(`#${this.id}-content`);

      return {
        $ancestor,
        hotspotEl,
        otherThumbnails,
        thumbnailEL,
        contentEl,
        otherLayers,
        $productMedia,
      };
    }

    constructor() {
      super();
    }

    _init() {
      super._init();

      this.addEventListener("click", (event) => {
        if (this.disabled || this.readOnly) {
          event.stopPropagation();
          event.preventDefault();
          event.cancelBubble = true;
          event.stopImmediatePropagation();

          return false;
        }

        this.onClick(event);
      });
    }

    mounted() {
      super.mounted();

      const { hotspotEl } = this.refs;

      $(hotspotEl).click(() => {
        this.onHotspotClick();
      });

      const contentSlotTemplate = this.querySelector(`template[slot="content"]`);

      this.slots.content = contentSlotTemplate.content;
    }

    onHotspotClick() {
      const { otherThumbnails, otherLayers } = this.refs;
      console.log("%c 1 --> Line: 96||interactive-layers.js\n otherLayers: ", "color:#f0f;", otherLayers);

      otherThumbnails.forEach((thumbnail) => {
        thumbnail.classList.add("opacity-0");
      });
      const hasActiveLayer = !!otherLayers.find(layer => !!layer.isOpen);

      hasActiveLayer ? this.change() : this.open();
    }

    onClick(e) {
      const { $ancestor, otherLayers } = this.refs;

      // Click on blank space
      if (e.target === e.currentTarget) {
        $ancestor.find("interactive-layer-content").removeClass("expanded");

        requestAnimationFrame(() => {
          otherLayers.forEach((layer) => layer.close());
          this.close();
        });
      }
    }

    open() {
      if (this.isOpen) return;

      const { $ancestor, $productMedia } = this.refs;

      $ancestor.find("interactive-layer-content").addClass("expanded");
      this.$el.addClass("is-open");
      $productMedia.addClass("interactive-layer--open");

      this.populateContent();
      this.calculateFrame();
      this.isOpen = true;
    }

    change() {
      const { otherLayers } = this.refs;

      otherLayers.forEach((layer) => {
        layer.isOpen = false;
        layer.$el.removeClass("is-open");
      });
      this.$el.addClass("is-open");

      this.populateContent();
      this.calculateFrame(true);
      this.isOpen = true;
    }

    close() {
      if (!this.isOpen) return;
      const { $ancestor, $productMedia } = this.refs;

      this.activeContent.remove();

      this.activeContent = null;
      this.$el.removeClass("is-open");
      $productMedia.removeClass("interactive-layer--open");
      $productMedia.css({
        "max-height": "",
        "aspect-ratio": "",
      });
      this.isOpen = false;
    }

    populateContent() {
      const { $ancestor } = this.refs;

      this.activeContent = $(this.slots.content.cloneNode(true).childNodes);
      $ancestor.find("interactive-layer-content").empty().append(this.activeContent);
    }

    calculateFrame(skip = false) {
      const { $ancestor, $productMedia } = this.refs;

      const $contentEl = $ancestor.find("interactive-layer-content");
      const contentElNative = $contentEl[0];
      const screenWidth = window.innerWidth;

      const isMobileScreen = screenWidth < 1024;

      if(isMobileScreen) return

      if (skip) {
        $productMedia.css({
          "max-height": $ancestor.height(),
          "aspect-ratio": "auto",
        });

      } else {
        const onTransitionEnd = (e) => {
          if (e.target !== contentElNative) return;

          $productMedia.css({
            "max-height": $ancestor.height(),
            "aspect-ratio": "auto",
          });

          contentElNative.removeEventListener("transitionend", onTransitionEnd);
        };
        contentElNative.addEventListener("transitionend", onTransitionEnd);
      }
    }
  }

  customElements.define("interactive-layer", InteractiveLayer);

  class InteractiveLayersService extends Element {
    constructor() {
      super();
    }

    async mounted() {
      super.mounted();

      const productMedia = document.querySelector("product-media");

      await waitUntil(() => !!productMedia.isInitialized);

      this.teleport(productMedia);
    }


    teleport(productMedia) {
      const playgroundTemplate = this.querySelector(`template[slot="playground"]`);
      const thumbnailTpl = this.querySelector(`template[slot="thumbnail"]`);


      productMedia.mediaCarousel.add(`<li class="splide__slide">
                                          ${playgroundTemplate.innerHTML}
                                        </li>`, 1);

      productMedia.thumbnailCarousel.add(`<li class="splide__slide">${thumbnailTpl.innerHTML}</li>`, 1);
    }


  }


  customElements.define("interactive-layers-service", InteractiveLayersService);

}



